export const articleCards = [
  {
    id: 1,
    title: 'OOPBUY Spreadsheet 2026: Der komplette Anfänger Guide',
    excerpt: 'Alles was du wissen musst, um mit dem OOPBUY Spreadsheet durchzustarten. Schritt-für-Schritt erklärt auf Deutsch.',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'Anfänger Guide',
    tagStyle: 'dark',
    imageSeq: 'ac-guide-01',
    imageQuery: 'Modern laptop displaying colorful spreadsheet data with product thumbnails on warm wooden desk, soft natural daylight streaming from window, clean minimal workspace aesthetic, cozy home office atmosphere, editorial photography style, warm neutral tones, authentic lifestyle scene',
  },
  {
    id: 2,
    title: 'OOPBUY Sicherheit: 7 wichtige Tipps vor deiner Bestellung',
    excerpt: 'Schütze dich vor Betrug und Fehlkäufen mit unseren geprüften Sicherheitsrichtlinien.',
    link: '/artikel/oopbuy-sicherheit',
    tag: 'Sicherheit',
    tagStyle: 'accent',
    imageSeq: 'ac-sicher-02',
    imageQuery: 'Stylish leather backpack displayed on light beige surface, soft natural lighting from side window, clean minimal product photography, premium travel accessory presentation, elegant composition with warm neutral tones, editorial catalog style, high-end fashion product shot',
  },
  {
    id: 3,
    title: 'OOPBUY Spreadsheet vs klassische Suche: Der Vergleich',
    excerpt: 'Welche Methode ist schneller und effizienter? Unser detaillierter Vergleich liefert die Antwort.',
    link: '/artikel/oopbuy-vergleich',
    tag: 'Vergleich',
    tagStyle: 'primary',
    imageSeq: 'ac-vergl-03',
    imageQuery: 'Classic aviator sunglasses with gold frame on warm cream background, soft diffused studio lighting, minimal luxury product photography, elegant reflections on lenses, sophisticated accessory presentation, high-end fashion catalog aesthetic, clean refined composition',
  },
  {
    id: 4,
    title: 'OOPBUY Kosten & Gebühren: Was kommt auf dich zu?',
    excerpt: 'Transparente Übersicht über alle Kosten, Versandgebühren und versteckte Ausgaben beim OOPBUY Einkauf.',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'Kosten',
    tagStyle: 'primary',
    imageSeq: 'ac-kosten-04',
    imageQuery: 'Elegant minimalist wristwatch with brown leather strap on light cream surface, soft natural daylight, premium product photography, refined sophisticated aesthetic, subtle warm shadows, luxury accessory catalog presentation, clean timeless composition',
  },
  {
    id: 5,
    title: 'OOPBUY Produkte finden: Tipps für die perfekte Suche',
    excerpt: 'Mit diesen Strategien findest du versteckte Produkte und sparst bei jedem Einkauf.',
    link: '/artikel/oopbuy-sicherheit',
    tag: 'Produktsuche',
    tagStyle: 'accent',
    imageSeq: 'ac-produkt-05',
    imageQuery: 'Premium knit sweater in warm oatmeal tone folded on light beige backdrop, soft natural lighting, clean minimal product photography, cozy autumnal aesthetic, high-quality textile texture visible, modern fashion catalog style, refined casual wear presentation',
  },
  {
    id: 6,
    title: 'OOPBUY Versand Guide: Lieferzeiten & Tracking',
    excerpt: 'Alles über Versandoptionen, Lieferzeiten nach Deutschland und wie du dein Paket verfolgst.',
    link: '/artikel/oopbuy-vergleich',
    tag: 'Versand',
    tagStyle: 'primary',
    imageSeq: 'ac-versand-06',
    imageQuery: 'Handcrafted ceramic coffee mug with minimalist design on warm wooden surface, soft morning light, clean aesthetic product photography, cozy lifestyle atmosphere, subtle steam effect, modern home goods catalog style, warm inviting composition',
  },
  {
    id: 7,
    title: 'OOPBUY Erfahrungen 2026: Echte Nutzerberichte',
    excerpt: 'Was sagen deutsche Käufer über OOPBUY? Erfahrungsberichte, Bewertungen und ehrliche Meinungen.',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'Erfahrungen',
    tagStyle: 'dark',
    imageSeq: 'ac-erfahr-07',
    imageQuery: 'Vintage inspired canvas sneakers in cream color on light neutral background, soft studio lighting, clean product photography, retro casual aesthetic, subtle texture details visible, modern streetwear catalog presentation, fresh warm composition',
  },
  {
    id: 8,
    title: 'OOPBUY Zahlung & Bezahlmethoden einfach erklärt',
    excerpt: 'Welche Zahlungsmethoden akzeptiert OOPBUY? Sicher bezahlen Schritt für Schritt.',
    link: '/artikel/oopbuy-sicherheit',
    tag: 'Zahlung',
    tagStyle: 'accent',
    imageSeq: 'ac-zahlung-08',
    imageQuery: 'Premium silk scarf with abstract geometric pattern in warm earth tones draped on light beige surface, soft diffused lighting, elegant product photography, luxury accessory presentation, subtle fabric texture, sophisticated fashion catalog aesthetic, refined artistic composition',
  },
  {
    id: 9,
    title: 'OOPBUY für Anfänger: Die ersten Schritte',
    excerpt: 'Noch nie bei OOPBUY bestellt? Diese Einsteiger-Anleitung macht den Start ganz einfach.',
    link: '/artikel/oopbuy-vergleich',
    tag: 'Anfänger',
    tagStyle: 'primary',
    imageSeq: 'ac-anfanger-09',
    imageQuery: 'Trendy beige crossbody bag with gold hardware on warm cream background, soft natural daylight, minimal product photography, modern minimalist aesthetic, clean sophisticated composition, contemporary accessory catalog style, elegant refined presentation',
  },
  {
    id: 10,
    title: 'OOPBUY Qualitätskontrolle: QC Bilder richtig nutzen',
    excerpt: 'So nutzt du Quality-Check-Bilder, um Produktqualität vor dem Versand zu prüfen.',
    link: '/artikel/oopbuy-spreadsheet-guide',
    tag: 'QC Guide',
    tagStyle: 'dark',
    imageSeq: 'ac-qc-10',
    imageQuery: 'Artisanal leather belt with intricate buckle detail on light cream surface, soft natural lighting from left side, clean product photography, premium craftsmanship visible, refined accessory presentation, sophisticated catalog style, warm inviting tones',
  },
  {
    id: 11,
    title: 'OOPBUY Spreadsheet Kategorien im Detail',
    excerpt: 'Alle 14 Kategorien verständlich erklärt – von Shoes bis Other Stuff.',
    link: '/artikel/oopbuy-sicherheit',
    tag: 'Kategorien',
    tagStyle: 'accent',
    imageSeq: 'ac-kat-11',
    imageQuery: 'Oversized cozy hoodie in warm taupe color on light beige background, soft studio lighting, minimal product photography, relaxed casual aesthetic, comfortable loungewear presentation, modern fashion catalog style, clean refined composition',
  },
  {
    id: 12,
    title: 'OOPBUY Günstige Produkte: Spartipps 2026',
    excerpt: 'Mit diesen Insider-Tipps findest du die besten Deals und reduzierst deine Kosten.',
    link: '/artikel/oopbuy-vergleich',
    tag: 'Spartipps',
    tagStyle: 'primary',
    imageSeq: 'ac-spar-12',
    imageQuery: 'Minimalist wool felt hat in soft charcoal grey on warm cream backdrop, soft directional lighting, clean product photography, refined classic aesthetic, elegant accessory presentation, premium quality visible, sophisticated catalog composition',
  },
];